import React from 'react';
import { createPortal } from 'react-dom';
import { ComponentType, Container } from '@philips-internal/oswald-ui-core';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
import { getLostProps, isFunction, propagateProps, trigger } from '@philips-internal/oswald-ui-utils';
import { InternalTab } from '../internal-tab/internal-tab.js';
import { TabWithContentProperties } from './tab-with-content-types.js';
import './tab-with-content.css';
const TabWithContentContainer = {
    acceptedTypes: [
        ComponentType.AGGREGATOR,
        ComponentType.BEHAVIOR,
        ComponentType.DATA_DISPLAY,
        ComponentType.FORM,
        ComponentType.LAYOUT,
        ComponentType.LIST,
    ],
    name: '',
};
function TabWithContent(props) {
    const { activeTab, children, name, onClick, onContextMenu, onDoubleClick, tabContentRef, uuid, } = props;
    const executeEvent = (callback) => {
        if (isFunction(callback)) {
            callback(new ClickEvent({ value: name }));
        }
    };
    const isActive = name ? activeTab === name : false;
    let content = null;
    if (isActive && tabContentRef) {
        content = (React.createElement(Container, { acceptedTypes: TabWithContentContainer.acceptedTypes, uuid: uuid }, propagateProps(children, getLostProps(TabWithContentProperties, props))));
    }
    return (React.createElement("div", { className: "c-tab-with-content" },
        React.createElement(InternalTab, { ...props, isActive: isActive, onClick: trigger(executeEvent, onClick), onContextMenuClick: trigger(executeEvent, onContextMenu), onDoubleClick: trigger(executeEvent, onDoubleClick) }),
        content ? createPortal(content, tabContentRef) : null));
}
export { TabWithContent, TabWithContentContainer, };
//# sourceMappingURL=tab-with-content.js.map